<template>
  <section id="cta">
    <div class="wrap">
      <div class="cta-card">
        <span class="eyebrow"><span class="dot"></span>{{ labelsState['lv_cta_eyebrow'] || 'Start today' }}</span>
        <h2 style="margin-top:18px">{{ labelsState['lv_cta_heading_pre'] || 'Your next sale' }} <span class="grad-text">{{ labelsState['lv_cta_heading_grad'] || 'closes in a chat.' }}</span></h2>
        <p>{{ labelsState['lv_cta_body'] || 'Activate NQA free for 14 days. No card, no commitment, onboarding included.' }}</p>
        <div class="cta-row">
          <a class="btn btn-primary btn-lg" :href="registerUrl" target="_blank">
            {{ labelsState['lv_cta_btn_primary'] || 'Create free account' }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <path d="M5 12h14M13 5l7 7-7 7"/>
            </svg>
          </a>
          <a class="btn btn-ghost btn-lg" :href="registerUrl" target="_blank">{{ labelsState['lv_cta_btn_secondary'] || 'Schedule 1-on-1 demo' }}</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'CTAV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return {
      labelsState: computed(() => labelsStore.labels),
      registerUrl: `${process.env.VUE_APP_DASHBOARD_URL}/auth/cover-register`,
    };
  },
};
</script>
